enum VideoTypes {
    STREAM = 'Stream',
    IFRAME = 'Iframe',
}

export default VideoTypes
